export const baseUrl = "http://app.aflax.net/";
